import { useTranslation } from 'react-i18next'
import React, { useEffect, useMemo } from 'react'
import styles from './matchScoreInput.module.scss'
import SetInput from './SetInput'
import { useFormikContext } from 'formik'
import { MatchFormatManagers } from 'forms/post-score'
import { FormState as PostScoreFormState } from 'forms/post-score/types'
import { SideEnum } from 'types/api/enums'

const MatchScoreInput = () => {
  const { t: tSocialMatches } = useTranslation('strSocialMatches')
  const {
    values: { score, scoreErrors, format },
    setFieldValue,
  } = useFormikContext<PostScoreFormState>()

  const scoreFormatManager = useMemo(() => MatchFormatManagers[format], [format])

  useEffect(() => {
    const updatedScore = scoreFormatManager.validateAndUpdate(score)
    setFieldValue('scoreErrors', scoreFormatManager.getErrors())
    if (updatedScore) setFieldValue('score', updatedScore)
  }, [score, setFieldValue, scoreFormatManager])

  if (!score) return null

  return (
    <div className={styles.matchScoreInput}>
      {score.sets.map((set, i) => {
        let tiebreak = set.type === 'set' ? set.tiebreak : undefined

        return (
          <SetInput
            key={i}
            score={{
              side1: { set: set.points.SIDE1, tiebreak: tiebreak ? tiebreak.points.SIDE1 : null },
              side2: { set: set.points.SIDE2, tiebreak: tiebreak ? tiebreak.points.SIDE2 : null },
            }}
            header={
              set.type === 'superTiebreak'
                ? `${tSocialMatches('postScore.matchScore.label.superTiebreak')}`
                : `${tSocialMatches('postScore.matchScore.label.set')} ${i + 1}`
            }
            pointsMaxSet={set.pointsMax}
            pointsMaxTiebreak={tiebreak?.pointsMax}
            winningSide={
              !tiebreak
                ? set.winner || undefined
                : set.winner && set.winner === tiebreak.winner
                ? set.winner
                : undefined
            }
            onScoreChange={({ scoreType, side, newScore }) => {
              const sideKey = side === 'side1' ? SideEnum.SIDE1 : SideEnum.SIDE2
              const key =
                scoreType === 'set'
                  ? `score.sets[${i}].points.${sideKey}`
                  : `score.sets[${i}].tiebreak.points.${sideKey}`

              setFieldValue(key, newScore)
            }}
            hasTiebreak={!!tiebreak}
            isEditable={set.isEditable}
            hasError={scoreErrors.some(err => err.setIndex === i)}
          />
        )
      })}
    </div>
  )
}

export default MatchScoreInput
